export function BaseProps(status = 'INACTIVE') {
	return {
		id: null,
		status,
		createdAt: null,
		updatedAt: null,
	}
}
